import React, { useEffect, useState } from 'react';
import Sidebar from './dashboard/sidebar';
import Navbar from './dashboard/navbar';

const MaintenancePage = () => {
    const [timeRemaining, setTimeRemaining] = useState(86400); // 24 heures en secondes
    const user_id = localStorage.getItem('user_id');

    useEffect(() => {
        const timer = setInterval(() => {
            setTimeRemaining((prev) => (prev > 0 ? prev - 1 : 0));
        }, 1000);

        return () => clearInterval(timer);
    }, []);

    const formatTime = (seconds) => {
        const hours = Math.floor(seconds / 3600);
        const minutes = Math.floor((seconds % 3600) / 60);
        const secs = seconds % 60;
        return `${hours.toString().padStart(2, '0')}:${minutes
            .toString()
            .padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
    };

    return (
        <div id="wrapper">
          <Sidebar user_id={user_id} />
          <div id="page-wrapper" className="gray-bg">
            <Navbar />
            <div className="maintenance-page">
                <h1>Site en maintenance</h1>
                <p>Nous travaillons à l'amélioration de notre site pour mieux vous servir.</p>
                {/* <p>Temps estimé avant retour : <strong>{formatTime(timeRemaining)}</strong></p> */}
                <p>Merci de votre patience !</p>
            </div>
          </div>
        </div>
    );
};

export default MaintenancePage;